import script from "./LoginPc.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginPc.vue?vue&type=script&setup=true&lang=ts"

import "../../style/LoginPc.css?vue&type=style&index=0&id=65eaa3b9&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65eaa3b9"]])

export default __exports__